export default __webpack_public_path__ + "static/media/bngo_winpannelhglt.306f0140.mp3";